export function mergeAdLists(...lists) {
  const byId = new Map();

  lists.flat().forEach((item) => {
    if (item?.Id) {
      byId.set(String(item.Id), item);
    }
  });

  return [...byId.values()];
}

export function hasMoreAds(pageSizes = [], threshold = 5) {
  return pageSizes.some((size) => Number(size) > threshold);
}
